import { Select, type SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

const ROLES = [
  { value: "owner", label: "Account Owner" },
  { value: "admin", label: "Company Admin" },
  { value: "manager", label: "Team Manager" },
  { value: "user", label: "Team Member" },
]

export function RoleSelect({ value, onChange, clearable, ...props }: Omit<SelectProps, "data">) {
  const { t } = useTranslation()
  const data = ROLES.map((role) => ({
    ...role,
    label: t(role.label),
  }))
  if (clearable) data.unshift({ value: "", label: "Not set" })
  return (
    <Select
      w="100%"
      label={`${t("Role")} (${t("on the service")})`}
      {...props}
      data={data}
      selectFirstOptionOnChange
      comboboxProps={{
        withinPortal: true,
      }}
      clearable={clearable}
      onChange={onChange}
      value={value ?? "user"}
    />
  )
}
